import { Stack, Typography } from '@mui/material';
import { memo } from 'react';

import Locked from '@vp/assets/icons/Locked.svg?react';
import { VpIcon } from '@vp/common/ui/component/VpIcon';
import { VpToggle } from '@vp/common/ui/component/VpToggle';

export type FullRestrictionPanelProps = {
  state: boolean;
  disabled: boolean;
  onToggle: () => void;
};

export const FullRestrictionPanel = memo<FullRestrictionPanelProps>(({ state, disabled, onToggle }) => {
  return (
    <Stack
      sx={{
        width: 1,
        borderRadius: '12px',
        backgroundColor: 'background.200',
        px: 3,
        py: 2,
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
      }}
    >
      <Stack gap={1} direction="row" alignItems="center">
        <VpIcon Icon={Locked} size={24} />

        <Stack>
          <Typography variant="body1Medium" color="text.secondary">
            Полное ограничение
          </Typography>

          <Typography variant="caption2Regular" color="text.disabled">
            Включая слайдшоу
          </Typography>
        </Stack>
      </Stack>

      <VpToggle state={state} disabled={disabled} onToggle={onToggle} />
    </Stack>
  );
});

FullRestrictionPanel.displayName = 'FullRestrictionPanel';
